module.exports = __webpack_public_path__ + "img/gb-eng.8f9ff293.svg";